import React, {useEffect, useRef} from 'react';
import './LeaderboardInt.css';
import LeaderBoardTopInt from "./LeaderBoardTopInt"
import RankingInt from '../LeaderboardInt/RankingInt';
import {useHistory} from "react-router-dom";
import Slider from "react-slick";
function LeaderboardInt(props) {
    const { data, myorg, swipeActions, scrollNav } = props;
    const topData = data?.teamRankings?.slice(0, 3)
    const belowData = data?.teamRankings?.slice(3, data?.teamRankings?.length);
    const history = useHistory();
    const sliderRef = useRef(null);
    useEffect(()=>{

    })
    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 3000,
        appendDots: (dots) => <ul>{dots}</ul>,
        customPaging: (i) => (
            <div className="slick-indicator"></div>
        ),
    };

  return (
      <>
      <div className="page-content page-content-leaderBoard">
          <div className="leader-board-table-data">
              <LeaderBoardTopInt data={topData} info={data?.info} />
              <RankingInt data={belowData} myorg={myorg}/>
          </div>
          <div className="leader-board-last-gainer">
              <h1>Top 3 Educators from our last campaign</h1>
              <p>and their Winnings</p>
              <div className="last-gainer-slider">
                  <Slider {...settings} ref={sliderRef} {...swipeActions}>
                      <div className="last-gainer-box">
                          <div className="gainer-img">
                              <img src="https://cdn-cp-assets-public.classplus.co/web/courseWebview/content/last-gainerHD1.png" alt="lastgainerimg1"/>
                          </div>
                      </div>
                      <div className="last-gainer-box">
                          <div className="gainer-img">
                              <img src="https://cdn-cp-assets-public.classplus.co/web/courseWebview/content/last-gainerHD2.png" alt="lastgainerimg2"/>
                          </div>
                      </div>
                      <div className="last-gainer-box">
                          <div className="gainer-img">
                              <img src="https://cdn-cp-assets-public.classplus.co/web/courseWebview/content/last-gainerHD3.png" alt="lastgainerimg3"/>
                          </div>
                      </div>
                  </Slider>

              </div>
          </div>

          <div className="leader-board-gift"
               onClick={() => {
                   scrollNav(1);
                   history.replace({pathname: '/tutor/details/tasks'})}}>
              <div className="gift-card">
                  <img src="https://cdn-cp-assets-public.classplus.co/web/courseWebview/content/aug-15-leaderboard-gift-cardHD-min.png" alt="leaderboardGiftCardPlayer"/>
              </div>
          </div>
          <div className="leader-board-bottom-img">
              <img src="https://cdn-cp-assets-public.classplus.co/web/courseWebview/content/aug-15-overview-bottom-img.png" alt="overviewbottomimg" />
          </div>
      </div>
      </>
  );
}

export default LeaderboardInt;
